jQuery(function ($) {

	/* =====================================================
	   js-in: 視界に入ったらフェードイン
	   ===================================================== */
	const jsInObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$(entry.target).addClass('is-active');
				jsInObserver.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0,
		rootMargin: '0px 0px -50px 0px'
	});


	/* =====================================================
	   fadeIn_list: 順番フェードイン（エリアごと）
	   ===================================================== */
	const fadeListObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const target = entry.target;
				const parent = target.parentElement;

				const siblings = Array.from(parent.querySelectorAll('.fadeIn_list'));
				const index = siblings.indexOf(target);

				setTimeout(() => {
					$(target).addClass('show');
				}, index * 150);

				fadeListObserver.unobserve(target);
			}
		});
	}, {
		threshold: 0,
		rootMargin: '0px 0px -100px 0px'
	});


	/* =====================================================
	   loadingComplete 後に全アニメーション開始
	   ===================================================== */
	document.addEventListener('loadingComplete', function () {

		// js-in 登録
		$('.js-in').each(function () {
			jsInObserver.observe(this);
		});

		// fadeIn_list 登録
		$('.fadeIn_list').each(function () {
			fadeListObserver.observe(this);
		});

		// js-load / js-load-more
		$('.js-load').delay(1000).queue(function () {
			$(this).addClass('is-active').dequeue();
		});

		$('.js-load-more').delay(2000).queue(function () {
			$(this).addClass('is-active').dequeue();
		});

	});

});
